module.exports = __webpack_public_path__ + "static/media/icon-phone.c0fabeb7.svg";